import type {TuiCapData} from './tuicap-engine'
import {TuiCapPlayer, type TuiCapPlayerProps} from './TuiCapPlayer'

// Loaded lazily (its own chunk) when the player nears the viewport.
const load = () => import('./demo-mobile.tuicap.json') as unknown as Promise<{default: TuiCapData}>

export default function DemoMobile(props: Omit<TuiCapPlayerProps, 'data' | 'load' | 'cols' | 'rows'>) {
  return <TuiCapPlayer load={load} cols={64} rows={33} {...props} />
}
